module.exports = __webpack_public_path__ + "media/images/header-logo-1c44c5c87bee7125c5f42b275435606d.png";